import { render, staticRenderFns } from "./HotelRoomModal.vue?vue&type=template&id=5b586f10&"
import script from "./HotelRoomModal.vue?vue&type=script&lang=js&"
export * from "./HotelRoomModal.vue?vue&type=script&lang=js&"
import style0 from "./HotelRoomModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports